import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import $ from "jquery";
import Server from '../../../functions/servername';
import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loadings';
import { Form, TextArea } from 'semantic-ui-react';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Request extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    update: false,
    maxWidth: 'xs',
    requestitems: []
  };

  remarks() {
    let masterData = this.props.masterData;
    let remarks = '';
    masterData.map((m) => {
      if (m.mid == this.props.mid) {
        remarks = m.remarks;
      }
    })
    this.setState({ remarks: remarks, dialog: true })
  }

  handleClose = () => {
    this.setState({ dialog: false })
  }

  submit() {
    let context = this;
    if (this.props.placeorderedit == 'none') {
      alert('You are not allow to change!!!!');
      return;
    }
    let remark = this.state.remarks;
    let masterData = this.props.masterData;
    this.setState({
      load: true,
      message: 'Update Remarks',
    })
    $.ajax({
      type: 'POST',
      data: { 'remarks': remark, 'id': context.props.mid },
      url:Server() + 'order/changeremarks.php',
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          masterData.map((m) => {
            if (m.mid == context.props.mid) {
              m.remarks = remark;
            }
          })
          context.props.updatemasterData(masterData);
          context.setState({ update: false })
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        })
      }
    })
  }

  handleTextBox = name => event => {
    this.setState({ [name]: event.target.value })
  }

  render() {
    let i = 0;
    let masterData = this.props.masterData;
    let remarks = '';
    masterData.map((m) => {
      if (m.mid == this.props.mid) {
        remarks = m.remarks;
      }
    })
    try {
      remarks = remarks.substring(0, 6);
    } catch (e) {
    }
    if (remarks.length == 0) {
      remarks = 'No Remarks';
    }
    else {
      remarks = remarks+'...';
    }
    return (
      <div style={{color: '#4574A3'}}>
        <u onClick={this.remarks.bind(this)}>{remarks}</u>
        <Loading load={this.state.load} message={this.state.message} />
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.dialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Remark`s</DialogTitle>
            <DialogContent>
              <DialogContentText>
                { this.state.update ?
                  (
                    <div>
                      <Form>
                        <TextArea onChange={this.handleTextBox('remarks')} fluid value={this.state.remarks} /><br/>
                      </Form>
                      <center><Button color="primary" onClick={this.submit.bind(this)}>Submit</Button></center>
                    </div>
                  ) :
                  (
                    <div>{this.state.remarks}</div>
                  )
                }
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              { this.state.update ?
                (
                  <div></div>
                ):
                (
                  <Button onClick={ () => { this.setState({ update: true }) }}>Change Remark</Button>
                )
              }
              <Button onClick={this.handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

Request.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Request);
